import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/not-found" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    // Перевірка на експірацію
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      // Токен протух
      return <Navigate to="/not-found" replace />;
    }
    
    return children;
  } catch (error) {
    // Якщо токен зіпсований або не розпарсився
    console.error("Invalid token:", error);
    return <Navigate to="/not-found" replace />;
  }
};

export default ProtectedRoute;
